import React from 'react';
import { Link } from 'react-router-dom';
import Navbar from '../../layout/Header/Navbar';

const ComingSoonScreen = () => {
  return (
    <>
        <section
        className='coming-soon-section min-vh-100 ptb-120 overflow-hidden position-relative w-100 d-flex flex-column justify-content-center'
        style={{
          background:
            "url('assets/img/page-header-bg.svg')no-repeat bottom right",
        }}
      >
        <div className='bg-dark fixed-bg'></div>
        <div className='container'>
          <div className='row'>
            <div className='col-lg-5 col-12'>
              <div className='coming-soon-content-wrap position-relative z-2'>
                <h5 className='text-white'>
                  <span className='fw-bold text-warning'>ABMS</span> Coming Soon...
                </h5>            
                    <h1 className='text-white'>
                  We are Working on Our New Product, Please Stay With us!
                </h1>
                <div className='action-btns'>
                  <Link
                    to='/contact-us'
                    className='btn btn-primary mt-5 popup-with-form'
                  >
                    Notify Me!
                  </Link>
                </div>

                <div className='social-list-wrap mt-100'>
                 <ul className="list-unstyled list-inline footer-social-list mb-0">
                  <li className="list-inline-item">
                    <a
                      href="https://www.facebook.com/senertech"
                      target="_blank"
                    >
                      <i className="fab fa-facebook-f"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.instagram.com/sener.tech"
                      target="_blank"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.linkedin.com/company/sener-tech"
                      target="_blank"
                    >
                      <i className="fab fa-linkedin"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a href="https://x.com/sener_tech" target="_blank">
                      <i className="fa fa-twitter"></i>
                    </a>
                  </li>
                  <li className="list-inline-item">
                    <a
                      href="https://www.youtube.com/@senertech"
                      target="_blank"
                    >
                      <i className="fab fa-youtube"></i>
                    </a>
                  </li>
                </ul>
                </div>
              </div>
            </div>
          </div>

          <ul className='animated-circle list-unstyled z--1'>
            <li className='transition-delay-1 bg-danger'></li>
            <li className='transition-delay-2 bg-warning'></li>
            <li className='transition-delay-3 bg-primary'></li>
          </ul>
        </div>
      </section>
    </>
  );
};

export default ComingSoonScreen;
